import { render, staticRenderFns } from "./pluspay-qrcode.vue?vue&type=template&id=18e06a88"
import script from "./pluspay-qrcode.vue?vue&type=script&lang=js"
export * from "./pluspay-qrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports